import { render, staticRenderFns } from "./AdminAssign.vue?vue&type=template&id=79be5358&lang=pug&"
import script from "./AdminAssign.vue?vue&type=script&lang=js&"
export * from "./AdminAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports